// src/stone/illustrations/AnimationWhatsappIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var AnimationWhatsappIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 95 96",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m.747 21.897 3.091 12.678.633 2.59.336 1.379 11.89 48.743c1.129 4.622 5.78 7.452 10.39 6.32l33.837-8.291c4.611-1.127 7.435-5.789 6.305-10.41L51.28 9.518c-1.126-4.62-5.776-7.451-10.387-6.323L23.19 7.535 7.056 11.487C2.445 12.619-.378 17.279.747 21.897"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m.747 21.897 3.091 12.678 16.77-15.228 7.308-6.642c-.876-.602-2.644-2.613-4.724-5.169l-16.136 3.95C2.445 12.62-.378 17.28.747 21.898M4.471 37.162l.336 1.38 14.508-13.039c.251-.23.166-.691-.065-.893-.284-.236-.634-.164-.89.065-1.604 1.448-3.221 2.896-4.825 4.34z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M36.455 91.31 73.1 82.33c3.947-.966 6.365-4.957 5.4-8.913L61.965 5.624C60.999 1.668 57.017-.755 53.07.213L16.423 9.192c-3.947.967-6.364 4.958-5.4 8.914l16.535 67.792c.967 3.956 4.95 6.38 8.897 5.412"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m32.203 79.67 39.31-9.632-14.21-58.254-39.311 9.632z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          stroke: "#FCFCFC",
          d: "m56.935 12.389 13.974 57.283-4.19 1.026-13.973-57.283z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M36.169 12.332c.991 0 1.795-.806 1.795-1.8 0-.993-.804-1.8-1.795-1.8-.992 0-1.796.807-1.796 1.8 0 .994.804 1.8 1.796 1.8"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EFF4F8",
          d: "M72.976 96.05c12.137 0 21.976-9.861 21.976-22.025S85.113 52 72.976 52 51 61.861 51 74.025 60.84 96.05 72.976 96.05"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "m61.056 86 1.758-6.42a12.36 12.36 0 0 1-1.654-6.192C61.163 66.558 66.722 61 73.552 61a12.31 12.31 0 0 1 8.766 3.633 12.3 12.3 0 0 1 3.626 8.764c-.003 6.83-5.562 12.388-12.392 12.388h-.005c-2.074 0-4.112-.52-5.922-1.507zm6.874-3.965.376.223a10.3 10.3 0 0 0 5.242 1.435h.004c5.677 0 10.298-4.619 10.3-10.296a10.23 10.23 0 0 0-3.014-7.285 10.23 10.23 0 0 0-7.282-3.02c-5.681 0-10.302 4.62-10.304 10.296 0 1.946.544 3.84 1.575 5.48l.245.39-1.04 3.8z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M70.455 68.209c-.251-.604-.507-.522-.697-.531a12 12 0 0 0-.593-.011c-.207 0-.542.077-.826.387s-1.084 1.059-1.084 2.582c0 1.524 1.11 2.996 1.265 3.202.155.207 2.183 3.334 5.29 4.674.738.32 1.315.51 1.764.652.742.236 1.417.203 1.95.123.596-.089 1.833-.749 2.09-1.472.259-.723.259-1.343.181-1.472-.077-.129-.284-.206-.593-.361-.31-.155-1.832-.904-2.116-1.007-.284-.104-.49-.155-.697.154-.206.31-.8 1.008-.98 1.214-.18.207-.361.233-.67.078s-1.308-.482-2.49-1.537c-.921-.82-1.543-1.834-1.723-2.144s-.02-.477.135-.632c.14-.138.31-.361.465-.542.155-.18.206-.31.31-.517.103-.206.051-.387-.026-.542-.078-.155-.697-1.678-.955-2.298"
        }
      )
    ]
  }
);
var AnimationWhatsappIllustration_default = AnimationWhatsappIllustration;

export {
  AnimationWhatsappIllustration,
  AnimationWhatsappIllustration_default
};
